import Joi from 'joi';

export const ptaxValidationSchema = Joi.object({
  status: Joi.boolean()
    .required()
    .messages({
      "any.required": "status is required.",
    }),
  ptax_ec_code: Joi.string()
    .pattern(/^\d{12}$/)  // Ensures exactly 17 numeric characters
    .required()
    .messages({
      "string.empty": "P-TAX(EC) Code is required.",
      "string.pattern.base": "P-TAX(EC) Code must be exactly 12 digits.",
      "any.required": "P-TAX(EC) Code is required.",
    }),
  ptax_rc_code: Joi.string()
    .pattern(/^\d{12}$/)
    .required("")
    .messages({
      "string.empty": "P-TAX(RC) Code is required.",
      "string.pattern.base": "P-TAX(RC) Code must be exactly 12 digits.",
      "any.required": "P-TAX(RC) Code is required.",
    }),
  financial_year: Joi.number()
    .required()
    .messages({
      "number.base": "Financial year is required.",
      "number.empty": "Financial year is required.",
      "any.required": "Financial year is required.",
      "number.pattern.base": "Financial year is required.",
    }),
  state: Joi.number()
    .integer()
    .positive()
    .required()
    .messages({
      "number.base": "State is required.",
      "number.integer": "State is required.",
      "number.positive": "State is required.",
      "any.required": "State is required.",
      "any.invalid": "State is required.",
    }),
});
